import React from 'react';

import { PDFDownloadLink } from '@react-pdf/renderer';
import { Spinner, Form, Col, Row } from 'react-bootstrap';

import { Button } from '../../../components';
import ClericalQuoteDocument from './Clerical/clericalPDF';
import DriversQuoteDocument from './Drivers/driversPDF';

const SaveButton = ({ quoteName, saveQuote }) => (
  <Button
    variant="primary"
    disabled={quoteName.length === 0 || saveQuote.isLoading}
    className="col-sm-5"
    onPress={() => saveQuote()}
    fullWidth>
    {saveQuote.isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
    <span>{!saveQuote.isLoading && 'SAVE'}</span>
  </Button>
);

const DownloadButton = ({ quoteDocument, quote }) => (
  <PDFDownloadLink document={quoteDocument} fileName={`quote_${quote.quoteId}.pdf`}>
    {({ loading, error }) => (
      <Button variant="primary" disabled={error || loading} className="col-sm-5" fullWidth>
        {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
        <span>{!loading && 'DOWNLOAD'}</span>
      </Button>
    )}
  </PDFDownloadLink>
);

const SaveDownloadForm = ({ quote, isSaved, onSaveClicked }) => {
  const [quoteName, setQuoteName] = React.useState(quote.quoteName || '');
  const saveQuote = async () => {
    await onSaveClicked(quoteName);
  };
  const quoteDocument =
    quote.quoteType?.toLowerCase() === 'clerical' ? (
      <ClericalQuoteDocument quote={{ ...quote, quoteName }} />
    ) : (
      <DriversQuoteDocument quote={{ ...quote, quoteName }} />
    );

  return (
    <>
      {isSaved ? (
        <DownloadButton quoteDocument={quoteDocument} quote={quote} />
      ) : (
        <>
          <Row>
            <Col>
              <Form>
                <Form.Group controlId="formAdminNumber">
                  <Form.Label>Name your quote</Form.Label>
                  <Form.Row>
                    <Col md>
                      <Form.Control
                        className="col-sm-5"
                        value={quoteName}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                        onChange={event => setQuoteName(event.target.value)}
                      />
                    </Col>
                  </Form.Row>
                </Form.Group>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col className="mt-2 mb-2">
              <SaveButton quoteName={quoteName} saveQuote={saveQuote} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default SaveDownloadForm;
